import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Snackbar } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import { designService } from '@paragon/data-connections';
import { hasPricesEditPermission } from '@paragon/login-tools';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { useAppSelector } from '../hooks';

export default function ExportButton() {
  const activePriceGrid = useAppSelector((state) => state.view.activePriceGrid);
  const [exportError, setExportError] = useState(false);
  const hasEditPermission = useAppSelector(hasPricesEditPermission);

  const click = async () => {
    try {
      switch (activePriceGrid) {
        case 'Lumber':
          const lumberPricesCsv = await designService.lumberPrices.exportLumberPrices();
          lumberPricesCsv.download('LumberPrices.csv');
          break;
        case 'Plates':
          const platePricesCsv = await designService.platePrices.exportPlatePrices();
          platePricesCsv.download('PlatePrices.csv');
          break;
        case 'Hangers':
          const hangerPricesCsv = await designService.hangerPrices.exportHangerPrices();
          hangerPricesCsv.download('HangerPrices.csv');
          break;
        default:
          assertExhaustiveSwitch(activePriceGrid);
      }
    } catch (error) {
      setExportError(true);
    }
  };

  const handleExportErrorMessageClose = () => setExportError(false);

  return (
    <>
      <Button variant="contained" sx={{ m: 1 }} onClick={() => click()} disabled={!hasEditPermission}>
        Export
      </Button>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={exportError}
        message="Error exporting"
        onClose={handleExportErrorMessageClose}
        action={[
          <IconButton aria-label="Close" color="inherit" onClick={handleExportErrorMessageClose}>
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </>
  );
}
